<ws-modal-wrapper [hideFooter]="true"
                  [excludeModalStyling]="true"
                  (cancel)="cancel()">
    <report-manager [modalParameters]="params" (saveModalClosed)="handleSaveModalClose($event)"></report-manager>
</ws-modal-wrapper>
